import { useEffect } from 'react';
import * as sessionStorage from 'modules/sessionStorage';

const SESSION_KEY = 'oneTapAlreadyPrompted';
const useGoogleOneTap = ({ clientId, callback, maxAttempts = 10, delay = 1000 }) => {
    useEffect(() => {
        let attempts = 0;
        let prompted = false;
        let alreadyPrompted = false;

        try {
            if (typeof window !== 'undefined') {
                alreadyPrompted = sessionStorage.getSessionItem(SESSION_KEY);
            }
        } catch (e) {
            // Intentionally empty: sessionStorage inaccessible (e.g., third-party context)
        }

        if (alreadyPrompted) return;
        const checkGoogle = () => {
            if (window.google?.accounts?.id && !prompted) {
                prompted = true;
                window.google.accounts.id.initialize({
                    client_id: clientId,
                    auto_select: false,
                    callback,
                });
                window.google.accounts.id.prompt(() => {
                    try {
                        sessionStorage.setItemForSession(SESSION_KEY, true);
                    } catch (e) {
                        // Intentionally empty: ignore storage failure
                    }
                });
            } else if (attempts < maxAttempts) {
                attempts++;
                setTimeout(checkGoogle, delay);
            }
        };

        setTimeout(checkGoogle, delay);
    }, [clientId, callback, maxAttempts, delay]);
};

export default useGoogleOneTap;
